import { useState, useEffect } from 'react'
import { useVersionCheck } from '../../hooks/useVersionCheck'
import { useServiceWorker } from '../../hooks/useServiceWorker'

const JUST_UPDATED_KEY = 'bt-vision-just-updated'

export function UpdateBanner() {
  const { updateAvailable, reload } = useVersionCheck()
  const { needRefresh, updateServiceWorker } = useServiceWorker()

  // Capture the just-updated flag once on mount so it survives async
  // hook state changes that trigger re-renders.
  const [suppressed] = useState(() => {
    const val = sessionStorage.getItem(JUST_UPDATED_KEY)
    if (val) {
      sessionStorage.removeItem(JUST_UPDATED_KEY)
      return true
    }
    return false
  })

  // If suppressed, silently activate the waiting SW so it doesn't linger
  useEffect(() => {
    if (suppressed && needRefresh) updateServiceWorker()
  }, [suppressed, needRefresh, updateServiceWorker])

  if (suppressed) return null

  const showBanner = updateAvailable || needRefresh
  if (!showBanner) return null

  const handleUpdate = async () => {
    sessionStorage.setItem(JUST_UPDATED_KEY, '1')
    // Always try to activate waiting SW first, so a reload
    // doesn't show the banner a second time for the SW update
    await updateServiceWorker()
    // If SW handled it, controllerchange triggers reload automatically.
    // Otherwise (no waiting SW), reload manually for version update.
    if (!needRefresh) {
      reload()
    }
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-md animate-fade-in">
      <div className="flex items-center justify-between gap-3 rounded-lg bg-turquoise/95 px-4 py-3 text-sm text-white shadow-lg backdrop-blur-sm">
        <span>Nova versão disponível!</span>
        <button
          onClick={handleUpdate}
          className="shrink-0 rounded-md bg-white/20 px-3 py-1 text-sm font-medium hover:bg-white/30 transition-colors"
        >
          Atualizar
        </button>
      </div>
    </div>
  )
}
